var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriorityFilterDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6471 10.9741H1.99166C1.76623 10.9741 1.60556 10.8883 1.50964 10.7168C1.41372 10.5453 1.43582 10.3835 1.57594 10.2312L4.33744 7.2259C4.39711 7.16055 4.42695 7.08784 4.42695 7.00775C4.42695 6.92767 4.39711 6.85496 4.33744 6.78961L1.57594 3.77408C1.43582 3.62185 1.41372 3.45999 1.50964 3.28849C1.60556 3.117 1.76623 3.03125 1.99166 3.03125H8.6345C8.80202 3.03125 8.96071 3.06034 9.11055 3.11851C9.25995 3.17706 9.38261 3.26262 9.47853 3.37519L12.3096 6.43717C12.4692 6.6064 12.549 6.79678 12.549 7.00832C12.549 7.21986 12.469 7.41024 12.309 7.57947L9.49113 10.6301C9.39521 10.7431 9.27233 10.8286 9.12248 10.8868C8.97308 10.9454 8.81462 10.9741 8.6471 10.9741Z",
    strokeWidth: 1.1375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityFilterDark);
export default __webpack_public_path__ + "static/media/priority-filter-dark.36bf75997be04f10d4d105772fc249fb.svg";
export { ForwardRef as ReactComponent };